import { UserInfoEngine } from '@memberjunction/core-entities';

/**
 * Whether the signed-in user may open the MJ Application a surface dashboard belongs to.
 *
 * Explorer filters the app list by `UserHasApplicationAccess`, but it restores a user's saved
 * workspace tabs without that check, so a tab saved while the user still had access mounts the
 * surface after the access is gone (Member Hub prod lock, 2026-10-28; MJ-072 in
 * docs/mj-upstream-defects.md). The surface therefore asks itself.
 *
 * Fails closed:
 * - The engine is loaded first. `UserHasApplicationAccess` treats an app with no ApplicationRole
 *   rows as open access, so an unloaded catalog would read as "allowed".
 * - A missing ApplicationID is refused for the same reason: there is no app to check against.
 */
export async function CurrentUserCanOpenApp(applicationId: string | null | undefined): Promise<boolean> {
    if (!applicationId?.trim()) return false;
    const engine = UserInfoEngine.Instance;
    await engine.Config(false);
    return engine.UserHasApplicationAccess(applicationId);
}
